import api from '@/api'

class Kabupaten {
  get () {
    return new Promise((resolve, reject) => {
      api.get('/v1/kabupaten_2018')
        .then(response => {
          let responseData = response.data
          if (responseData.success) {
            resolve(responseData.data)
          }
        })
        .catch(e => {
          // FIXME: Tell our user when we got some errors
          reject(e.response)
        })
    })
  }

  getOne (id) {
    return new Promise((resolve, reject) => {
      api.get(`/v1/kabupaten_2018/${id}`)
        .then(response => {
          let responseData = response.data
          if (responseData.success) {
            resolve(responseData.data)
          }
        })
        .catch(e => {
          // FIXME: Tell our user when we got some errors
          reject(e.response)
        })
    })
  }

  getByProvinsi (idProvinsi) {
    return new Promise((resolve, reject) => {
      api.get(`/v2/kabupaten_2018_by_provinsi/${idProvinsi}`)
        .then(response => {
          let responseData = response.data
          if (responseData.success) {
            resolve(responseData.data)
          }
        })
        .catch(e => {
          // FIXME: Tell our user when we got some errors
          reject(e.response)
        })
    })
  }

  post (body) {
    return new Promise((resolve, reject) => {
      api.post('/v1/kabupaten_2018', body)
        .then(response => {
          let responseData = response.data
          if (responseData.success) {
            resolve(responseData)
          }
        })
        .catch(e => {
          // FIXME: Tell our user when we got some errors
          reject(e.response)
        })
    })
  }

  update (body, id) {
    return new Promise((resolve, reject) => {
      api.put(`/v1/kabupaten_2018/${id}`, body)
        .then(response => {
          let responseData = response.data
          if (responseData.success) {
            resolve(responseData)
          }
        })
        .catch(e => {
          // FIXME: Tell our user when we got some errors
          reject(e.response)
        })
    })
  }

  delete (id) {
    return new Promise((resolve, reject) => {
      api.delete(`/v1/kabupaten_2018/${id}`)
        .then(response => {
          let responseData = response.data
          if (responseData.success) {
            resolve(responseData)
          }
        })
        .catch(e => {
          // FIXME: Tell our user when we got some errors
          reject(e.response)
        })
    })
  }
}

export default new Kabupaten()



// WEBPACK FOOTER //
// ./src/helper/data-master/kabupaten.js